import JSZip from "jszip";
import { makeFolderName, removeLeadingSlash, removeTrailingSlash, splitPath } from "../paths";
//import { unProcessAndSaveProcessedGraph } from "../graph/graphloader";
import { writeFile } from "../dwclient/dwstorage";
import { findFileSystemRoot2 } from "../graph/graphstorage2";
import { findChildrenOfNodeById2, findNodeId2, firstLink2, mkdirs2, newFile2, newFolder2, } from "../graph/graphmodifier2";
import { determineMimeType } from "../mimetype";
const FOLDER_IMPORTED = "/Imported";
export const isZip = (file) => {
    return (file.type == "application/zip" ||
        file.type == "multipart/x-zip" ||
        file.type == "application/zip-compressed" ||
        file.type == "application/x-zip-compressed" ||
        file.type == "application/x-zip" ||
        file.name.endsWith(".zip"));
};
export const isZipFileContent = async (file) => {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const zip = await JSZip.loadAsync(arrayBuffer);
        //console.log("isZipFile true");
        return true;
    }
    catch (error) {
        //console.log("isZipFile false");
        return false;
    }
};
export const unzip = async (provider, processedGraph, zipFile, storageProps) => {
    const zip = await JSZip.loadAsync(zipFile);
    const createZipFolderResult = createZipFolder(processedGraph, zipFile); // TODO try-catch
    const { zipFolderNodeId, absoluteZipFolderPath } = createZipFolderResult;
    const folderCache = {};
    for (const [relativePath, file] of Object.entries(zip.files)) {
        //console.log(relativePath, file);
        if (file.dir) {
            const dirName = removeLeadingSlash(removeTrailingSlash(file.name));
            const folderId = mkdirs2(processedGraph, zipFolderNodeId, dirName);
            folderCache[dirName] = folderId;
            //console.log("Adding folderCache[" + dirName + "]=" + folderId);
        }
        else {
            const fileContent = await file.async("blob");
            //console.log("blob properties:", fileContent.size, fileContent.type);
            const mimeType = await determineMimeType(relativePath, fileContent);
            const extractedFile = new File([fileContent], relativePath, {
                type: mimeType,
                lastModified: new Date().getTime(),
            });
            let absoluteFileName;
            if (fileContent.size > 0) {
                absoluteFileName = makeFolderName(absoluteZipFolderPath, file.name);
                // console.log("Writing file to:", absoluteFileName);
                const writeFileResult = await writeFile(provider, storageProps, absoluteFileName, extractedFile);
                // console.log(writeFileResult);
            }
            else {
                absoluteFileName = "";
            }
            const nameParts = splitPath(file.name);
            // console.log("nameParts:", nameParts);
            /* console.log(
              "Creating node:",
              nameParts?.name ?? extractedFile.name,
              extractedFile.size,
              mimeType,
              absoluteFileName,
              extractedFile.lastModified,
            );*/
            const newFileId = newFile2(processedGraph, nameParts?.name ?? extractedFile.name, extractedFile.size, mimeType, absoluteFileName, extractedFile.lastModified);
            let folderCacheQuery;
            if (nameParts?.folder === undefined) {
                folderCacheQuery = "";
            }
            else {
                folderCacheQuery = removeLeadingSlash(nameParts.folder);
            }
            const parentFolderId = folderCache[folderCacheQuery] ?? zipFolderNodeId;
            // console.log("Cache query: " + folderCacheQuery + " => " + parentFolderId);
            // console.log("Linking: parent=", parentFolderId, "child=", newFileId);
            firstLink2(processedGraph, parentFolderId, newFileId);
            //newFile(processedGraph, )
        }
    }
};
const createZipFolder = (processedGraph, zipFile) => {
    const fileSystemRoot = findFileSystemRoot2(processedGraph);
    const importedFolderId = findNodeId2(processedGraph, FOLDER_IMPORTED, fileSystemRoot?.id);
    if (importedFolderId === undefined) {
        // console.log(FOLDER_IMPORTED + " not found");
        throw new Error("Imported folder not found");
    }
    const zipFolderName = generateZipFolderName(processedGraph, importedFolderId, zipFile.name);
    // console.log("generated ZIP folder name", zipFolderName);
    const tmpNodeId = newFolder2(processedGraph, zipFolderName);
    const zipFolderNodeId = firstLink2(processedGraph, importedFolderId, tmpNodeId);
    // console.log("ZIP folder node id:", zipFolderNodeId);
    return { zipFolderNodeId, absoluteZipFolderPath: makeFolderName(FOLDER_IMPORTED, zipFolderName) };
};
const generateZipFolderName = (processedGraph, parentFolderId, name) => {
    const nodes = findChildrenOfNodeById2(processedGraph, parentFolderId);
    // console.log(nodes);
    const nameParts = splitPath(name);
    let folderNameToTry = nameParts?.nameWithoutExtension;
    if (folderNameToTry === undefined) {
        throw new Error("Problem with ZIP file name: " + name);
    }
    // console.log("Trying", folderNameToTry);
    if (tryFolderName(nodes, folderNameToTry)) {
        return folderNameToTry;
    }
    const folderNamePrefixToTry = folderNameToTry;
    let num = 0;
    let success = false;
    do {
        num++;
        folderNameToTry = folderNamePrefixToTry + "-" + num;
        // console.log("Trying", folderNameToTry);
        success = tryFolderName(nodes, folderNameToTry);
    } while (!success);
    return folderNameToTry;
};
const tryFolderName = (nodes, folderNameToTry) => {
    return nodes.find((node) => node.label.toString() === folderNameToTry) === undefined;
};
